var map = {
	"./80level.png": "./app/assets/images/competitions/digital_art/partners/media/80level.png",
	"./andy_sowards.png": "./app/assets/images/competitions/digital_art/partners/media/andy_sowards.png",
	"./concept_art_world.png": "./app/assets/images/competitions/digital_art/partners/media/concept_art_world.png",
	"./freeyork.png": "./app/assets/images/competitions/digital_art/partners/media/freeyork.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/assets/images/competitions/digital_art/partners/media sync recursive ^\\.\\/.*\\.png$";